import { motion } from "framer-motion";

// Signature colourful dot-cluster motif (echoes the NEAD logo petals).
const COLORS = ["#e6007e", "#1ba7e0", "#fdec44", "#80d2ea", "#ff8e4c", "#ffffff"];

// deterministic pseudo-random
function rand(seed) {
  const x = Math.sin(seed * 99.13) * 43758.5453;
  return x - Math.floor(x);
}

function build(count) {
  const dots = [];
  for (let i = 0; i < count; i++) {
    const a = rand(i + 1) * Math.PI * 2;
    const rad = 8 + rand(i + 7) * 46;
    const cx = 50 + Math.cos(a) * rad * (0.9 + rand(i + 3) * 0.3);
    const cy = 50 + Math.sin(a) * rad * 0.75;
    dots.push({
      cx,
      cy,
      r: 0.9 + rand(i + 11) * 3.4,
      color: COLORS[Math.floor(rand(i + 5) * COLORS.length)],
      delay: rand(i + 2) * 0.9,
    });
  }
  return dots;
}

export default function DotCluster({ className = "", count = 90, animate = true }) {
  const dots = build(count);
  return (
    <svg viewBox="0 0 100 100" className={className} aria-hidden="true">
      {dots.map((d, i) => (
        <motion.circle
          key={i}
          cx={d.cx}
          cy={d.cy}
          r={d.r}
          fill={d.color}
          initial={animate ? { opacity: 0, scale: 0 } : false}
          animate={animate ? { opacity: 1, scale: 1 } : {}}
          transition={{ duration: 0.6, delay: d.delay, ease: [0.16, 1, 0.3, 1] }}
          style={{ transformOrigin: `${d.cx}px ${d.cy}px` }}
        />
      ))}
    </svg>
  );
}
